import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/CSS/fonts.css'
// 阿里适量库图标
import './assets/CSS/Taishi/iconfont.css'
// 引入GSAP和ScrollTrigger
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import i18n from './lang' // 引入 i18n 配置
// 引入全局动画插件
// 注册ScrollTrigger插件
gsap.registerPlugin(ScrollTrigger)
import './assets/CSS/global.css'  // 引入全局样式
// 方式一：通过 Vue.prototype 全局挂载
Vue.prototype.$gsap = gsap
Vue.config.productionTip = false
Vue.prototype.$ScrollTrigger = ScrollTrigger
new Vue({
    i18n, // 挂载
    router,
    render: h => h(App)
}).$mount('#app')
